import axios, { AxiosRequestConfig } from "axios";
import { buscaTipo, updateTipoBusca } from "../types/tipo";
import { Tipo } from "../types/usuarios";

export const getTipo = async (token: string): Promise<Tipo[]> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/tipo`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar tipos:", error);
    throw error;
  }
};

export const getTipoById = async (
  token: string,
  id: string
): Promise<buscaTipo> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/tipo/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar tipo:", error);
    throw error;
  }
};

export const createTipo = async (token: string, tipoData: FormData) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/tipo`;
    const response = await axios.post(url, tipoData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar tipo:", error);
    throw error;
  }
};

export const updateTipo= async (
  token: string,
  id: string,
  tipoData: updateTipoBusca
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/tipo/${id}`;
    const response = await axios.put(url, tipoData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar tipo:", error);
    throw error;
  }
};

export const deleteTipo = async (token: string, id: number) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/tipo/${id}`;
    const response = await axios.delete(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao excluir tipo:", error);
    throw error;
  }
};

export const deleteTipoUser = async (token: string, id: number) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/tipousuario/${id}`;
    const response = await axios.delete(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao excluir tipo do usuário:", error);
    throw error;
  }
};
